import GlobalChip from './Chip';

export default GlobalChip;
